/**
 * OZONE — recently viewed prices from Liquid context, not /products/{handle}.js.
 * Ajax Product API does not return B2B catalog prices; Liquid does.
 */
(function () {
  if (!window.theme || !theme.RecentlyViewed) return;

  function hasContextualPrice(payload) {
    if (!payload) return false;
    try {
      var product = typeof payload === 'string' ? JSON.parse(payload) : payload;
      return !!(product && product.eoo_price_context);
    } catch (e) {
      return false;
    }
  }

  var cached = theme.recentlyViewed && theme.recentlyViewed.productInfo;
  if (cached && typeof cached === 'object') {
    var stale = false;
    Object.keys(cached).forEach(function (key) {
      if (!hasContextualPrice(cached[key])) stale = true;
    });
    if (stale) theme.recentlyViewed.productInfo = {};
  }

  var proto = theme.RecentlyViewed.prototype;
  if (!proto || typeof proto.getProductInfo !== 'function') return;

  proto.getProductInfo = function (handle) {
    return new Promise(function (resolve) {
      if (theme.recentlyViewed.productInfo.hasOwnProperty(handle) && hasContextualPrice(theme.recentlyViewed.productInfo[handle])) {
        resolve(theme.recentlyViewed.productInfo[handle]);
        return;
      }

      var root = (theme.routes && theme.routes.home) ? theme.routes.home : '/';
      if (root.slice(-1) !== '/') root += '/';

      fetch(root + 'products/' + encodeURIComponent(handle) + '?view=ajax-json', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (text) {
          var start = text.indexOf('{');
          var end = text.lastIndexOf('}');
          resolve(start === -1 || end === -1 ? null : text.slice(start, end + 1));
        })
        .catch(function () {
          resolve(null);
        });
    });
  };
})();
